import { __assign } from "tslib";
import { useCallback, useRef, useState } from 'react';
import { useOutsideClick } from './useOutsideClick.js';
export function useSuggestionList() {
    var el = useRef(undefined);
    var suggestPromise = useRef(undefined);
    var _a = useState({
        isVisible: false,
        cursor: -1,
        loading: false,
        suggestions: [],
    }), suggestionsInfos = _a[0], setSuggestionsInfos = _a[1];
    var handleClickOutsideSuggestions = useCallback(function () {
        setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { isVisible: false })); });
    }, []);
    var loadSuggestions = useCallback(function (results) {
        setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: -1, loading: !!results, isVisible: false, suggestions: [] })); });
        if (results) {
            if (suggestPromise.current) {
                suggestPromise.current.active = false;
            }
            var sp_1 = {
                active: true,
            };
            Promise.resolve(results)
                .catch(function () { return []; })
                .then(function (suggestions) {
                if (sp_1.active) {
                    setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { loading: false, suggestions: suggestions, isVisible: true })); });
                }
            });
            suggestPromise.current = sp_1;
        }
    }, []);
    useOutsideClick(el, handleClickOutsideSuggestions);
    return [el, suggestionsInfos, setSuggestionsInfos, loadSuggestions];
}
//# sourceMappingURL=useSuggestionList.js.map